import { BaseRouteService } from "core/services";

class NoteRouteService extends BaseRouteService {
	constructor() {
		super("case-notes");	
	}	
	
	find(filter) {
		// debugger
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,trackingCaseId}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

	update(resource) {
		return super.update(`${this.base}/{id}`, resource);	
	}	
	
	delete(resource) {		
		return super.delete(`${this.base}/{id}`, resource);	
	}
}

export default NoteRouteService;